import request from '../../request'
import { UseQueryResult, useQuery } from 'react-query'
import { useBuildQueryParams } from '../../../lib/hooks/useBuildQueryParams'
import { ReportGeneratorRequest } from '@demandlocal/utils/lib/mongo/models/ReportGeneratorRequest'

export const useGetAgencyExportById = ({
  id,
  filters,
}: {
  id?: string
  filters: Record<string, unknown>
}): UseQueryResult<ReportGeneratorRequest<'agency'>, Error> => {
  const queryParams = useBuildQueryParams(filters)

  return useQuery<ReportGeneratorRequest<'agency'>, Error>(
    ['agencies', 'exports'],
    ({ signal }) =>
      request({
        url: `/agencies/${queryParams?.agency_id}/reports/exports/${id}`,
        method: 'GET',
        params: {
          ...queryParams,
        },
        signal,
      }),
    {
      enabled: !!(queryParams?.agency_id && id),
    },
  )
}
